import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { ProjectBody, PublicProjectBody } from '../models/project.model';
import { IProjectsStore } from './projects.store';

/**
 * This is the state of the Project slice.
 */
export interface ProjectState {
  currentProject: PublicProjectBody | ProjectBody | null;
}

/**
 * Actions related to the Project state.
 */
export interface ProjectActions {
  setProject: (project: NonNullable<ProjectState['currentProject']>) => void;
  setProjectVisibility: (visibility: { is_public: boolean; is_team_shared: boolean }) => void;
}

export type ProjectSlice = {
  project: ProjectState & ProjectActions;
};

/**
 * Creates the Project slice. This function can be merged into
 * a larger store (e.g., a projects store).
 */
export const createProjectSlice: StateCreator<IProjectsStore, [], [], ProjectSlice> = (set) => ({
  project: {
    currentProject: null,

    setProject: (project: NonNullable<ProjectState['currentProject']>) =>
      set(
        produce((draft: IProjectsStore) => {
          draft.project.currentProject = project;
        })
      ),

    setProjectVisibility: (visibility: { is_public: boolean; is_team_shared: boolean }) =>
      set(
        produce((draft: IProjectsStore) => {
          const project = draft.project.currentProject;
          
          if (project) {
            project.is_public = visibility.is_public;
            
            if ('is_team_shared' in project) {
              project.is_team_shared = visibility.is_team_shared;
            }
          }
        })
      ),
  },
});
